import { IAttributeDefinition } from "@wingspanhq/payments/dist/interfaces";

export interface FieldCounts {
  required: number;
  optional: number;
}

export function selectorFieldCounts(
  attributeDefinitions: IAttributeDefinition[]
): FieldCounts {
  return attributeDefinitions.reduce(
    (acc, field) => {
      if (field.required) {
        acc.required += 1;
      } else {
        acc.optional += 1;
      }
      return acc;
    },
    { required: 0, optional: 0 }
  );
}
